import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { Box, Typography } from "@mui/material";
import { DashboardCardStyle } from "../DashboardContent/style";
import { NoDataContainer } from "../../Common/styles/table";
import { groupPieColors } from "../DashboardContent/dashboard";

const CustomPieTooltip = ({ active, payload }: any) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const data = payload[0].payload;

  return (
    <Box
      sx={{
        backgroundColor: "#FFF",
        padding: "8px 12px",
        borderRadius: "6px",
        border: "1px solid #E5E7EB",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
        <Box
          sx={{
            width: 12,
            height: 12,
            borderRadius: "50%",
            backgroundColor: data.color,
          }}
        />
        <Typography variant="caption" fontWeight={600} color="text.primary">
          {data.label}
        </Typography>
      </Box>
      <Typography variant="caption" color="text.secondary">
        Count: {data.valueLabel}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
        ({data.value}%)
      </Typography>
    </Box>
  );
};

const renderCustomLabel = (props: any) => {
  const { cx, cy, midAngle, outerRadius, label, valueLabel } = props;

  const RADIAN = Math.PI / 180;
  const radius = outerRadius + 22;

  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#111827"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
      fontSize={14}
      fontWeight={600}
    >
      {label}: {valueLabel}
    </text>
  );
};

const TotalPeopleAcrossGroupPie = ({ data }: any) => {
  const originalPieData = data?.data || [];

  const filteredPieData = originalPieData
    .map((item: any, index: number) => ({
      ...item,
      originalIndex: index,
    }))
    .filter((item: any) => item.value > 0);

  return (
    <Box sx={DashboardCardStyle}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight="medium"
          color="text.primary"
        >
          {data?.title || "Total Participant Across Groups"}
        </Typography>
      </Box>
      {filteredPieData.length > 0 ? (
        <Box sx={{ height: "360px", width: "100%" }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <defs>
                {groupPieColors.map((color: string, index: number) => (
                  <linearGradient
                    key={`pieGradient-${index}`}
                    id={`pieGradient-${index}`}
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop offset="0%" stopColor={color} stopOpacity={0.95} />
                    <stop offset="50%" stopColor={color} stopOpacity={0.75} />
                    <stop offset="100%" stopColor={color} stopOpacity={0.55} />
                  </linearGradient>
                ))}
              </defs>
              <Pie
                data={filteredPieData}
                cx="50%"
                cy="50%"
                innerRadius={70}
                outerRadius={120}
                paddingAngle={2}
                cornerRadius={4}
                dataKey="value"
                label={renderCustomLabel}
                labelLine={{
                  stroke: "#9CA3AF",
                  strokeWidth: 1,
                }}
              >
                {filteredPieData.map((entry: any) => (
                  <Cell
                    key={`cell-${entry.originalIndex}`}
                    fill={`url(#pieGradient-${
                      entry.originalIndex % groupPieColors.length
                    })`}
                    stroke="#FFF"
                    strokeWidth={2}
                  />
                ))}
              </Pie>
              <Tooltip content={<CustomPieTooltip />} />
            </PieChart>
          </ResponsiveContainer>
        </Box>
      ) : (
        <NoDataContainer>
          <Typography variant="body1" color="gray">
            No Data
          </Typography>
        </NoDataContainer>
      )}
    </Box>
  );
};

export default TotalPeopleAcrossGroupPie;
